import { View, ViewConfig } from '@lernetz/ts-lib/src/view/View';
import { Iframely, IframelyView } from '@lernetz/ui-components/src/iframely/Iframely';
import template from './DecoratedIframely.html';

import baseIframeTemplate from "./Iframely.html";

export class DecoratedIframely extends Iframely {

    caption: string;
    widthStyle: string;

    public constructor( dto ) {
        super( dto );
    }

}

export class DecoratedIframelyView extends View<DecoratedIframely> {

    public constructor( config?: ViewConfig<DecoratedIframely> ) {
        super( { template, ...config } );
        this.registry.add( 'Iframely', () => new IframelyView({ template: baseIframeTemplate}) );
    }
}
